import React from 'react';
import { BusinessNameField } from './components/BusinessNameField';
import { BusinessStateField } from './components/BusinessStateField';
import { TitleSelectField } from './components/TitleSelectField';

interface CompanyInfoPanelProps {
    showCompanyPanel: boolean;
    readOnlyNameField?: boolean;
    readOnlyStateField?: boolean;
    readOnlyTitleField?: boolean;
}

export const CompanyInfoPanel: React.FC<CompanyInfoPanelProps> = ({
    showCompanyPanel,
    readOnlyNameField = false,
    readOnlyStateField = false,
    readOnlyTitleField = false,
}) => {
    if (!showCompanyPanel) return null;

    return (
        <>
            <div className='field-section'>
                <div className='field-row'>
                    <BusinessNameField readOnly={readOnlyNameField} />
                    <BusinessStateField readOnly={readOnlyStateField} />
                    <TitleSelectField readOnly={readOnlyTitleField} />
                </div>
            </div>
        </>
    );
};
